// extracted by mini-css-extract-plugin
export default {"list":"RecipesList_list__L9OKr","card":"RecipesList_card__JxupY"};